import { checkVendorCommercialRequired, checkVendorIdentity } from './rules.js';
import { vendorEditFormFieldsSchema } from './update-form.js';
export const vendorCreateFormSchema = vendorEditFormFieldsSchema.superRefine((values, context) => {
    // Per-field required messages (no combined message) — matches the per-field error UX this
    // branch standardises on (see also per-field P2002 routing).
    for (const issue of checkVendorIdentity(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
    // Mirrors createVendorInputSchema — payment terms/ship terms/carrier are required
    // (same check vendorEditFormSchema runs).
    for (const issue of checkVendorCommercialRequired(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
//# sourceMappingURL=create-form.js.map